import React, { Component } from 'react'
import { navigateTo } from 'gatsby-link'
import FixedSize from '../components/FixedSize'

import introMP4 from '../video/intro.mp4'
import introWebM from '../video/intro.webm'

export default class Index extends Component {
    toMenu = () => {
        navigateTo('/menu')
    }

    render() {
        return (
            <div className="vertical-center"
                style={{ backgroundColor: '#f8f8f8' }}>
                <video style={{ width: '100%', height: '100%' }}
                    onError={this.toMenu}
                    onEnded={this.toMenu}
                    autoPlay muted>
                    <source src={introMP4} type="video/mp4" />
                    <source src={introWebM} type="video/webm" />
                </video>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/index.js